export enum WebsiteSourceEnum {
  ChooseTemplate = 'chooseTemplate',
  StartFromScratch = 'startFromScratch',
}

export const websiteSourceLocoKeys = {
  [WebsiteSourceEnum.ChooseTemplate]: 'dashboard.website.website_source_choose_template',
  [WebsiteSourceEnum.StartFromScratch]: 'dashboard.website.website_source_start_from_scratch',
}
